import React, { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import QuizQuestionMain from "./QuizQuestionMain";
import randomCombPolitehnika, { IrandomCombPolitehnika } from "../helpers/randomCombPolitehnika";
import questionMain, { IQuestionMain } from "../helpers/questionMain";
import submitQuestionMain from "../helpers/submitQuestionMain";
import fillZeroMain from "../helpers/fillZeroMain";
import getScoreQuiz from "../helpers/getScoreQuiz";

interface DnevnaNagradaProps {
  email: string;
  code: string;
}

const DnevnaNagrada: React.FC<DnevnaNagradaProps> = (props) => {
  const [data, setData] = useState<IrandomCombPolitehnika | boolean>(false);
  const [que, setQue] = useState<IQuestionMain | null>(null);
  const [redni, setRedni] = useState<number>(1);
  const [timeLeft, setTimeLeft] = useState<number>(120);
  const [score, setScore] = useState<number | null>(null);
  const [isFinished, setIsFinished] = useState<boolean>(false);
  const [isAnswering, setIsAnswering] = useState<boolean>(false);
  const [isFetchingQuestion, setIsFetchingQuestion] = useState<boolean>(false);

  const navigate = useNavigate();
  const hasFetchedData = useRef(false);

  const handleButtonClick = () => {
    navigate("/prijava", {});
  };

  const startTimer = () => {
    const timer = setInterval(() => {
      setTimeLeft((prevTime) => {
        if (prevTime <= 0) {
          clearInterval(timer);
          return 0;
        }
        return prevTime - 1;
      });
    }, 1000);
  };
  const formatTime = (seconds: number) => {
    const minutes = Math.floor(seconds / 60).toString().padStart(2, '0');
    const secs = (seconds % 60).toString().padStart(2, '0');
    return `${minutes}:${secs}`;
  };
  
  const fetchQuestionData = async (currentRedni: number) => {
    if (isFetchingQuestion) return;
    setIsFetchingQuestion(true);

    try {
      if (data && typeof data === "object" && "main_combination_id" in data) {
        const newdata = await questionMain(currentRedni, data.main_combination_id);
        setQue(newdata as IQuestionMain | null);
        setIsAnswering(false);
      } else {
        console.error("combId nije dostupan ili je nevalidan.");
      }
    } catch (error) {
      console.error("Greška pri dohvatanju podataka:", error);
    } finally {
      setIsFetchingQuestion(false);
    }
  };

  const fetchScore = async (combId: string) => {
    try {
      const result = await getScoreQuiz(combId);
      if (result && typeof result === "object" && "score" in result) {
        setScore(result.score);
      } else {
        console.error("Neuspešan API poziv za score-quiz.");
      }
    } catch (error) {
      console.error("Greška pri dohvatanju rezultata:", error);
    }
  };

  const fillzero = async (combId: string) => {
    try {
      await fillZeroMain(combId);
    } catch (error) {
      console.error("Greška pri pozivu fillZeroMain funkcije:", error);
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      if (hasFetchedData.current) return;
      hasFetchedData.current = true;

      try {
        const newdata = await randomCombPolitehnika(props.email, props.code);
        if (newdata && typeof newdata === "object" && "main_combination_id" in newdata) {
          setData(newdata);
          startTimer();
        } else {
          console.error("randomCombPolitehnika nije vratio validan odgovor.");
        }
      } catch (error) {
        console.error("Greška pri dohvatanju podataka:", error);
      }
    };

    fetchData();
  }, [props.email, props.code]);

  useEffect(() => {
    if (data && typeof data === "object" && "main_combination_id" in data && !isFinished) {
      fetchQuestionData(redni);
    }
  }, [data]);

  useEffect(() => {
    if ((timeLeft <= 0 || redni > 10) && data && typeof data === "object" && "main_combination_id" in data && !isFinished) {
      setIsFinished(true);
      fetchScore(data.main_combination_id);
      fillzero(data.main_combination_id);
    }
  }, [timeLeft, redni, data, isFinished]);

  const onAnswerSelected = async (option: string) => {
    if (isAnswering || isFetchingQuestion) return;

    setIsAnswering(true);
    try {
      if (que && data && typeof data === "object" && "main_combination_id" in data) {
        const combId = data.main_combination_id;

        await submitQuestionMain(que.main_question_id_record, option, combId);

        const nextRedni = redni + 1;
        setRedni(nextRedni);

        await fetchQuestionData(nextRedni);
      } else {
        console.error("combId ili que nije dostupan.");
      }
    } catch (error) {
      console.error("Greška pri slanju odgovora ili dohvatanju sledećeg pitanja:", error);
    } finally {
      setIsAnswering(false);
    }
  };

  if (isFinished) {
    return (
      <div className="zahvalnica">
        <h1>
            Vaš rezultat je <br />
            <span className="score-value">{score !== null ? score : "Računam..."}</span> poena
        </h1>

        <button onClick={handleButtonClick}>Pokreni novi kviz</button>
      </div>
    );
  }

  return (
    <div className="kivz">
      {/* <h2>Preostalo vreme:</h2>
      <div>{timeLeft} sekundi</div> */}

      {que && (
        <QuizQuestionMain
          questionId={que.main_question_id_record}
          options={[
            que.question_answer1,
            que.question_answer2,
            que.question_answer3,
            que.question_answer4,
          ]}
          onAnswerSelected={onAnswerSelected}
        />
      )}

        {/* <h2>Preostalo vreme:</h2> */}
        <div className="timer-visual">
          <img src="/clock-icon.png" alt="Clock" className="timer-icon" />
            <span className="timer-text">{formatTime(timeLeft)}</span>
          </div>
        </div>
  );
};

export default DnevnaNagrada;
